module.exports = __webpack_public_path__ + "static/media/banner_zxs.883ae2bc.png";